import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { sequence } from '@angular/animations';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-evaluation-master',
  standalone: false,
  templateUrl: './evaluation-master.component.html',
  styleUrl: './evaluation-master.component.scss'
})
export class EvaluationMasterComponent implements OnInit, OnDestroy {
  title = 'Evaluation Criteria';
  equipments: any[]=[];
  showDialog: boolean = false;
  cols: any[] = [
    { field: 'sequence', header: 'Ser', filterType: 'text', width: '30px', minWidth: '30px', maxWidth: '100px' },
    { field: 'category', header: 'Criteria Category', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'name', header: 'Criteria Name', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px' },
  ];
  selectedequipment: any;
  showDeleteDialog: boolean = false;
  viewMode: boolean = false;
  formData: any = {};
  
  matrixOptions = [
    { label: 'TECHNICAL EVALUATION MATRIX', value: 'TECHNICAL EVALUATION MATRIX' },
    { label: 'VENDOR EVALUATION MATRIX', value: 'VENDOR EVALUATION MATRIX' },
    { label: 'COMMERCIAL BID', value: 'COMMERCIAL BID' }
  ];
  
  dialogConfig: DialogConfig = {
    title: 'Add Evaluation Criteria',
    width: '60vw',
    height: 'auto',
    maximizable: true,
    closable: true,
    dismissableMask: true,
    formLayout: 'single-column',
    fields: [
      {
        key: 'matrixType',
        label: 'Matrix Type',
        type: 'select',
        required: true,
        placeholder: 'Select Matrix Type',
        options: this.matrixOptions,
        validation: {
          required: true
        }
      },
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        required: true,
        placeholder: 'Enter Criteria Name',
        maxLength: 500,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'sequence',
        label: 'Sequence',
        type: 'number',
        required: true,
        placeholder: 'Enter Sequence Number',
        maxLength: 15,
        validation: {
          required: true,
          pattern: '^[0-9]+$'
        },
        patternErrorMessage: 'Sequence must be a valid number.'
      }
    ],
    submitButtonText: 'Submit',
    cancelButtonText: 'Cancel',
    showCancelButton: true
  };
  
  private subscriptions = new Subscription();


  constructor(private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    // Initialize dialog config with matrix options
    this.updateDialogConfig();
  }
  
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  
  private updateDialogConfig(): void {
    this.dialogConfig.fields[0].options = this.matrixOptions;
  }
  totalRecords: number = 0;
  currentPage = 1;
  getCriteria(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();
    this.currentPage = page;

    let url = `/master/evalution/criteria/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
      this.equipments = res.data || res.results
      this.totalRecords = res.count || 0
    });
    this.subscriptions.add(sub);
  }

  addCriteria() {
    this.viewMode = false;
    this.formData = {};
    this.dialogConfig.title = 'Add Evaluation Criteria';
    this.dialogConfig.submitButtonText = 'Submit';
    this.showDialog = true;
  }

  onSubmitCriteria(formData: any) {
    let payload = {
      name: formData.name,
      category: formData.matrixType,
      sequence: formData.sequence,
    };
    
    if (this.selectedequipment && this.selectedequipment.id) {
      // Update existing criteria
      const sub = this.api.putAPI(`/master/evalution/criteria/${this.selectedequipment.id}/`, payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Criteria updated successfully'
          });
          this.showDialog = false;
          this.getCriteria({ page: this.currentPage });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: res.detail || 'Failed to update criteria'
          });
        }
      });
      this.subscriptions.add(sub);
    } else {
      // Add new criteria
      const sub = this.api.postAPI('/master/evalution/criteria/', payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Evaluation criteria added successfully',
          });
          this.showDialog = false;
          this.getCriteria({ page: this.currentPage });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: res.name || 'Failed to add criteria',
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }
  viewSystem(rowData: any) {
    this.viewMode = true;
    this.selectedequipment = rowData;
    this.dialogConfig.title = 'View Evaluation Criteria';
    this.dialogConfig.submitButtonText = 'Close';
    this.dialogConfig.showCancelButton = false;
    
    this.formData = {
      name: rowData.name || '',
      matrixType: rowData.category || '',
      sequence: rowData.sequence || '',
    };
    
    this.showDialog = true;
  }

  onUpdateCriteria(equipment: any): void {
    this.viewMode = false;
    this.selectedequipment = equipment;
    this.dialogConfig.title = 'Update Evaluation Criteria';
    this.dialogConfig.submitButtonText = 'Update';
    this.dialogConfig.showCancelButton = true;
    
    this.formData = {
      name: equipment.name || '',
      matrixType: equipment.category || '',
      sequence: equipment.sequence || '',
    };
    
    this.showDialog = true;
  }

  onCancelDialog(): void {
    this.showDialog = false;
    this.selectedequipment = null;
    this.formData = {};
  }

  onCloseDialog(): void {
    this.showDialog = false;
    this.selectedequipment = null;
    this.formData = {};
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedequipment = equipment
  }
  deleteequipment() {
    // this.selectedequipment = equipment;
    let sectionId = this.selectedequipment.id
    const sub = this.api.deleteAPI(`/master/evalution/criteria/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Criteria Deleted Successfully',
        });
        this.showDeleteDialog = false
        this.getCriteria();

      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the criteria. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);

  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/evaluation', 'Edit') ||
      this.permissionService.hasPrivilege('/master/evaluation', 'Delete')||
         this.permissionService.hasPrivilege('/master/evaluation', 'View');
  }
}
